// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1wdIB","title":"Images90_title__3skBo","images":"Images90_images__1bcy2"};